function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref931"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref931"] = parcelRequire;
}
parcelRequire.register("4SSe9", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $38e644f71e40bb30$export$6503ec6e8aabbaf; }, function (v) { return $38e644f71e40bb30$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $38e644f71e40bb30$export$f7ad0328861e2f03; }, function (v) { return $38e644f71e40bb30$export$f7ad0328861e2f03 = v; });
var $38e644f71e40bb30$export$6503ec6e8aabbaf;
var $38e644f71e40bb30$export$f7ad0328861e2f03;
"use strict";
var $38e644f71e40bb30$var$mapping = {};
function $38e644f71e40bb30$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$38e644f71e40bb30$var$mapping[keys[i]] = pairs[keys[i]];
}
function $38e644f71e40bb30$var$resolve(id) {
    var resolved = $38e644f71e40bb30$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$38e644f71e40bb30$export$6503ec6e8aabbaf = $38e644f71e40bb30$var$register;
$38e644f71e40bb30$export$f7ad0328861e2f03 = $38e644f71e40bb30$var$resolve;

});

var $bb36038c2e212a58$exports = {};

(parcelRequire("4SSe9")).register(JSON.parse('{"5BSJE":"index.72ef4b60.js","hxcGQ":"about-us.f2f047ba.jpeg","7koew":"fetch.ba39af06.js","awiG3":"index.0c344416.css"}'));


//# sourceMappingURL=index.f65b6815.js.map
